import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelpersService } from "./helpers.service";
import { catchError, map, Observable, of } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable()

export class AuthService extends HelpersService {

    public verifiedPhone: boolean = false;

    constructor(router: Router, http: HttpClient, translate: TranslateService, dialog: MatDialog) {
        super(router, http, translate, dialog)
    }

    public reset(token: string): Observable<any> {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/enrollment-token?token=${token}`, {}, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public confirm(token: string): Observable<any> {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/confirmation?token=${token}`, {}, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public sendNewOtp(token: string): Observable<any> {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/phone-validation?token=${token}`, {}, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public validateOtp(token: string, req: any): Observable<any> {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/phone-validation?token=${token}`, req, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updateEmailRequest(req: any): Observable<any> {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/email-update`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getUpdateEmailRequest(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/email-update`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public validateUpdateEmail(req: any): Observable<any> {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/email-update/validate`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updatePhoneRequest(req: any): Observable<any> {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/phone-number-update`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public validateUpdatePhone(req: any): Observable<any> {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/phone-number-update/validate`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getTermsDocuments(token: string) {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/agreements?token=${token}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {     
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getTermsConsents(token: string) {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/consents?token=${token}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {     
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public sendTermsConsents(token: string, req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/consents?token=${token}`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {     
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public provisioningPassword(token: string, req: any) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/account?token=${token}`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getPasswordPolicy(token: string): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/password-policy?token=${token}`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getAccessToken(req: any) {
        const params = new URLSearchParams(req);
        let headerObj: any = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/ld+json'
        };
        if(this.config.APIGEE_API_KEY) {
            headerObj = {...headerObj, "apiKey": this.config.APIGEE_API_KEY};
        }
        let headers = {
            headers: new HttpHeaders(headerObj)
        };
        return this.http.post(`${this.config.BASEURL_AUTH_API}/oauth2/token`, params, headers).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getUserInfo(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/contact`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }
    
    public updateUserAddresses(req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/addresses`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updateUserInfo(req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public updateSecurityQuestions(req: any) {
        return this.http.patch(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/security-questions`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getSecurityQuestions(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/secured/security-questions?locale=${this.lang}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getPassStrength(): Observable<any> {
        return this.http.get(`https://reqres.in/api/users?page=2`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getPrefixes(): Observable<any> {
        return this.http.get(`${this.config.BASEURL_ACCOUNT_API}/v2/settings/telephone-prefixes`, this.getHTTPHeader()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getLocationByCode(code: string) {
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/secured/location-codes/${code}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public getFilteredLocations(foreign?: number, terms?: string) {
        let params = '';
        if (foreign) {
            params += `&foreign=${foreign}`
        }
        if (terms) {
            params += `&terms=${terms}`
        }
        return this.http.get(`${this.config.BASEURL_SETTINGS_API}/v1/secured/location-codes?${params}`, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    // {
    //     "gender": "MALE",
    //     "birth_place_code": "H501",
    //     "birth_date": "1995-09-27",
    //     "first_name": "Daniele",
    //     "last_name": "D'Arienzo",
    //     "fiscal_code": "DRNDNL95P27H501Q"
    // }
    public validateFiscalCode(req: any) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/secured/customer/fiscal-code/validate`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }
    
    public getDocumentsTC(token: string) {
        return `${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/agreements/terms-conditions?token=${token}`;
    }
    public getDocumentsPolicy(token: string) {
        return `${this.config.BASEURL_ACCOUNT_API}/v2/enrollment/agreements/privacy?token=${token}`;
    }

    public getAutomotiveRenewalOtp(token: string) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/renewal/verify-token?token=${token}`, {}, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error, true);
            })
        )
    }

    public getAutomotiveRenewalNewToken(token: string) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/renewal/resend-token?token=${token}`, {}, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error, true);
            })
        )
    }

    public validateAutomotiveRenewalOtp(token: string, req: any) {
        return this.http.post(`${this.config.BASEURL_ACCOUNT_API}/v2/renewal/verify-otp?token=${token}`, req, this.getHTTPHeader(true)).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error, true);
            })
        )
    }
}